export const SET_USR_DETAILS="SET_USR_DETAILS"
export const SET_DOC_DETAIL="SET_DOC_DETAIL"
export const SET_ISAPPOINTMENT_SLOT_OPEN="SET_ISAPPOINTMENT_SLOT_OPEN";
export const SET_APPOINTMENT="SET_APPOINTMENT";
export const SET_APPOINTMENT_LIST="SET_APPOINTMENT_LIST";
export const SET_APPOINTMENT_COUNTS = "SET_APPOINTMENT_COUNTS";
export const OPEN_LOGIN_MODAL = "OPEN_LOGIN_MODAL";
export const CLOSE_LOGIN_MODAL = "CLOSE_LOGIN_MODAL";
export const OPEN_SIGNUP_MODAL = "OPEN_SIGNUP_MODAL";
export const CLOSE_SIGNUP_MODAL = "CLOSE_SIGNUP_MODAL";



const initialState = {
  userDetails: {  },
  selectedDoctorDetails: { },
  isAppointmentSlotOpen:false,
  setAppointment:{},
  patientAppointmentList:[],
appointmentCounts: {
    Confirm: 0,
    Scheduled: 0,
    Completed: 0,
    Canceled: 0,
    Active: 0,
    Rescheduled: 0,
    Missed: 0,
  },
    isLoginModalOpen: false,
    isSignupModalOpen:false,
}
  
const rootReducer = (state = initialState, action:any) => {
  switch (action.type) {
          case SET_USR_DETAILS:
      return { ...state, userDetails: action.payload };
          case SET_DOC_DETAIL:
      return { ...state, selectedDoctorDetails: action.payload };
          case SET_ISAPPOINTMENT_SLOT_OPEN:
      return { ...state,  isAppointmentSlotOpen: action.payload };
          case SET_APPOINTMENT:
      return { ...state, setAppointment: action.payload };
          case SET_APPOINTMENT_LIST:
      return { ...state, patientAppointmentList: action.payload };
          case SET_APPOINTMENT_COUNTS:
      return {
        ...state,
        appointmentCounts: {
          ...state.appointmentCounts,
          ...action.payload,
        },
      };  
          case OPEN_LOGIN_MODAL:
      return { ...state, isLoginModalOpen: true };
          case CLOSE_LOGIN_MODAL:
      return { ...state, isLoginModalOpen: false };
            case OPEN_SIGNUP_MODAL:
      return { ...state, isSignupModalOpen: true };
          case CLOSE_SIGNUP_MODAL:
      return { ...state, isSignupModalOpen: false };

      
    default:
      return state;
  }        
};         

export default rootReducer;
